import React from 'react'
import TextInput from '../inputs/TextInput'

interface ClassPropertyFieldProps {
	value: string
	onChange: (value: any) => void
	placeholder?: string
}

export default function ClassPropertyField({ value, onChange, placeholder }: ClassPropertyFieldProps) {
	return (
		<div className="space-y-2">
			<TextInput value={value || ''} onChange={(v) => onChange({ value: v })} placeholder={placeholder || 'minha-classe'} />
		</div>
	)
}


